import React from 'react';
import FadeIn from '../components/ui/FadeIn';
import Button from '../components/ui/Button';
import SafeIcon from '../common/SafeIcon';

const PackageCard = ({ title, target, content, price, ctaText, highlighted = false }) => (
  <div className={`relative flex flex-col p-10 md:p-12 rounded-[3rem] transition-all duration-500 h-full ${highlighted ? 'bg-brand-dark text-white shadow-2xl scale-100 lg:scale-105 z-10 border border-brand-accent/30' : 'bg-white border border-black/5 hover:modern-shadow'}`}>
    {highlighted && (
      <div className="absolute -top-5 left-1/2 -translate-x-1/2 bg-brand-accent text-white text-xs font-bold px-8 py-2.5 rounded-full uppercase tracking-[0.2em] shadow-lg">
        Premium Choice
      </div>
    )}
    
    <h3 className={`text-4xl font-serif mb-4 ${highlighted ? 'text-brand-accent' : 'text-brand-dark'}`}>{title}</h3>
    
    <p className={`text-base font-light mb-10 pb-10 border-b ${highlighted ? 'border-white/10 text-white/70' : 'border-brand-dark/10 text-brand-text'}`}>
      <span className="font-bold block mb-3 text-xs uppercase tracking-[0.15em] opacity-80">Für wen?</span>
      {target}
    </p>

    <div className="flex-grow">
      <ul className="space-y-5 mb-12">
        {content.map((item, idx) => (
          <li key={idx} className="flex items-start gap-4">
            <SafeIcon name="Check" className={`w-5 h-5 shrink-0 mt-0.5 ${highlighted ? 'text-brand-accent' : 'text-brand-dark'}`} />
            <span className={`text-base font-light leading-relaxed ${highlighted ? 'text-white/90' : 'text-brand-text'}`}>{item}</span>
          </li>
        ))}
      </ul>
    </div>

    <div className="mt-auto pt-8">
      <div className="mb-3 text-xs font-bold uppercase tracking-[0.2em] opacity-60">Investment</div>
      <div className={`text-3xl font-serif mb-10 ${highlighted ? 'text-white' : 'text-brand-dark'}`}>
        {price}
      </div>
      <Button 
        to="/kontakt" 
        variant={highlighted ? 'primary' : 'outline'} 
        className={`w-full !py-5 ${highlighted ? '!bg-brand-accent !text-white hover:!bg-brand-dark' : ''}`}
      >
        {ctaText}
      </Button>
    </div>
  </div>
);

const Packages = () => {
  return (
    <div className="pt-32 pb-32 bg-brand-cream min-h-screen">
      <div className="container mx-auto px-6 max-w-7xl">
        <FadeIn className="text-center mb-24 max-w-3xl mx-auto">
          <span className="text-brand-accent font-bold tracking-[0.2em] uppercase text-sm mb-6 block">Dein Investment</span>
          <h1 className="text-5xl md:text-7xl font-serif mb-8 text-brand-dark">Klarheit. <span className="italic text-brand-accent">Wachstum.</span></h1>
          <p className="text-xl text-brand-text font-light">
            Transparente Pakete für deinen nächsten großen Schritt. Wähle die Begleitung, die exakt zu deinem Level passt.
          </p>
        </FadeIn>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 md:gap-6 lg:gap-8 items-stretch max-w-7xl mx-auto">
          <FadeIn delay={0.1} className="h-full">
            <PackageCard 
              title="Glow Check"
              target="Frauen, die sofort wissen möchten, warum ihr Instagram-Profil noch nicht die gewünschten Premium-Kunden anzieht."
              content={[
                "Tiefgehende Profil-Analyse",
                "Bio- & Highlight-Optimierung",
                "Konkrete Content-Empfehlungen",
                "Aktionsplan als Video-Feedback"
              ]}
              price="ab 149 €"
              ctaText="Profil analysieren"
            />
          </FadeIn>

          <FadeIn delay={0.2} className="h-full">
            <PackageCard 
              title="Intensive Mentoring"
              target="Für Beauty-Expertinnen, die ihr Business ganzheitlich, messbar und nachhaltig auf Premium-Level skalieren wollen."
              content={[
                "Komplette Instagram-Strategie",
                "Pricing & Paket-Strukturierung",
                "Intensives Mindset-Coaching",
                "Laufender 1:1 WhatsApp Support",
                "Tiefe strategische Live-Sessions"
              ]}
              price="Auf Anfrage"
              ctaText="Mentoring anfragen"
              highlighted={true}
            />
          </FadeIn>

          <FadeIn delay={0.3} className="h-full">
            <PackageCard 
              title="Studio System"
              target="Für etablierte Studios, die ein automatisiertes, digitales System für mehr Zeit und Auslastung benötigen."
              content={[
                "Digitaler Buchungsprozess",
                "CRM / Tool-Implementierung",
                "Automatisierte Erinnerungen",
                "Strategischer Review-Aufbau"
              ]}
              price="ab 1.500 €"
              ctaText="System besprechen"
            />
          </FadeIn>
        </div>
      </div>
    </div>
  );
};

export default Packages;